module.exports = __webpack_public_path__ + "static/tygus-inc-logo-5b3e0a5705651aeff8ce993067dae0c7.png";